import { Box } from '@mui/material';
import { getResultBadgeStyles } from '../helpers';
import { COMPACT_WIDGET_VIEWPORT_QUERY } from '../styles';
import type { MatchResult } from '../types';

type ResultBadgeProps = {
  result: MatchResult;
};

const ResultBadge = ({ result }: ResultBadgeProps) => (
  <Box
    component='span'
    sx={{
      minWidth: 20,
      px: 0.5,
      py: 0.125,
      borderRadius: '6px',
      typography: 'caption',
      fontWeight: 800,
      textAlign: 'center',
      [COMPACT_WIDGET_VIEWPORT_QUERY]: {
        minWidth: 16,
        px: 0.25,
      },
      ...getResultBadgeStyles(result),
    }}
  >
    {result}
  </Box>
);

export default ResultBadge;
